import PropTypes from 'prop-types';
import { ChevronDown } from 'lucide-react';
import { Text, Stack } from '@/components/ui/index.js';
import styles from './SelectItem.module.css';

/**
 * SelectItem - Settings row with custom select dropdown
 * Used for choosing from multiple options like language, theme, visibility
 */
export function SelectItem({
  icon: Icon,
  label,
  value,
  options,
  onChange,
  disabled = false,
  className = '',
  ...props
}) {
  const classNames = [
    styles.item,
    disabled && styles.disabled,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const selectedOption = options.find(opt => opt.value === value);
  const displayValue = selectedOption?.label || value;

  return (
    <div className={classNames} {...props}>
      <Stack direction="row" gap={3} align="center" className={styles.left}>
        {Icon && (
          <div className={styles.iconWrapper}>
            <Icon size={20} strokeWidth={2} />
          </div>
        )}
        <Text size="base" color="primary" className={styles.label}>
          {label}
        </Text>
      </Stack>
      <div className={styles.right}>
        <div className={styles.selectWrapper}>
          <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            className={styles.select}
          >
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ChevronDown size={16} className={styles.chevron} />
        </div>
      </div>
    </div>
  );
}

SelectItem.propTypes = {
  icon: PropTypes.elementType,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default SelectItem;
